enum ActivityOtherFilter {
  UNSYNCHRONIZED = 'unsynchronized'
}

export default ActivityOtherFilter;
